import type { ItemDef } from "../types";
import { MATERIAL_CHUNKS } from "../materials";

const ALL: ItemDef[] = [...MATERIAL_CHUNKS];
const BY_ID = new Map<string, ItemDef>(ALL.map((i) => [i.id, i]));

export function getItemDef(id: string): ItemDef {
  const def = BY_ID.get(id);
  if (!def) throw new Error(`unknown item id: ${id}`);
  return def;
}

export { defineItem } from "./define";
